/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ResourceAssignmentMode = 'AUTOMATIC' | 'BLOCKED' | 'MANUAL';

export const ResourceAssignmentMode = {

    AUTOMATIC: 'AUTOMATIC' as ResourceAssignmentMode,

    BLOCKED: 'BLOCKED' as ResourceAssignmentMode,

    MANUAL: 'MANUAL' as ResourceAssignmentMode
};

